<section class="tabs">
    <ul>
        <li [ngClass]="{'active': tipoEstadisticas === 4}" (click)="showDesignacionesEtiquetadores()">
            {{'centralEstadisticas.designaciones.tabs.nDesignacionesEtq.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 5}" (click)="showKilosPais()">
            {{'centralEstadisticas.designaciones.tabs.kilosPais.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 6}" (click)="showKilosDenominacion()">
            {{'centralEstadisticas.designaciones.tabs.kilosDenominacion.titulo' | translate}}
        </li>
        <li [ngClass]="{'active': tipoEstadisticas === 8}" (click)="showKilosEtiquetadores()">
            {{'centralEstadisticas.designaciones.tabs.kilosEtiquetadores.titulo' | translate}}
        </li>
    </ul>
    <content>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 4">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section">
                        <div>
                            <h3>{{'centralEstadisticas.designaciones.tabs.nDesignacionesEtq.paisDenominacionCampanya' | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasDesignacionesFiltroCompleto && graficasDesignacionesFiltroCompleto.graficasTab4">
                        <div class="container" *ngFor="let grafica of graficasDesignacionesFiltroCompleto.graficasTab4">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="true" [nombre]="('centralEstadisticas.designaciones.nDesignaciones' | translate)" [title]="'(' + ('centralEstadisticas.pais' | translate) + grafica.pais + ' / ' + ('centralEstadisticas.denominacion' | translate) + grafica.denominacion + ' / ' + ('centralEstadisticas.campanya' | translate) + (grafica.anyo) + ')'"
                                            [categorias]="grafica.etiquetadores" [data]="grafica.numDesignaciones" [valorMaximo]="grafica.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.nDesignacionesEtq.preDescripcionPaisDenominacionCampanya' | translate) + grafica.denominacion + ('centralEstadisticas.designaciones.tabs.nDesignacionesEtq.postDescripcionPaisDenominacionCampanya' | translate) + grafica.pais"><i class="fa-solid fa-info"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 5">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section" style="justify-content: center;">
                        <div>
                            <h3>{{'centralEstadisticas.designaciones.tabs.kilosPais.paisDenominaciones' | translate}}</h3>
                        </div>
                    </div>  
                    <div class="" *ngIf="graficasDesignacionesFiltroCompleto && graficasDesignacionesFiltroCompleto.graficasTab5">
                        <div class="container">
                            <div class="grafica">
                                <lib-grouped-bar-chart [horizontal]="true" [nombre]="'Kg'"
                                            [categorias]="graficasDesignacionesFiltroCompleto.graficasTab5[0].categorias" [data]="graficasDesignacionesFiltroCompleto.graficasTab5[0].designaciones"
                                            [colors]="graficasDesignacionesFiltroCompleto.graficasTab5[0].colores" [valorMaximo]="graficasDesignacionesFiltroCompleto.graficasTab5[0].valorMaximo"></lib-grouped-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.kilosPais.descripcionPaisDenominaciones' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section">
                        <div>
                            <h3>{{'centralEstadisticas.designaciones.tabs.kilosPais.paisKilos' | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasDesignacionesFiltroCompleto && graficasDesignacionesFiltroCompleto.graficasTab5">
                        <div class="container" *ngFor="let grafica of graficasDesignacionesFiltroCompleto.graficasTab5[1]">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="true" [nombre]="'Kg'" [title]="'(' + ('centralEstadisticas.denominacion' | translate) + grafica.denominacion + ' / ' + ('centralEstadisticas.campanya' | translate) + (grafica.anyo) + ')'"
                                            [categorias]="grafica.paises" [data]="grafica.kilos" [valorMaximo]="grafica.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.kilosPais.preDescripcionPaisKilos' | translate) + grafica.denominacion + ('centralEstadisticas.designaciones.tabs.kilosPais.postDescripcionPaisKilos' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 6">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section">
                        <div>
                            <h3>{{'centralEstadisticas.designaciones.tabs.kilosDenominacion.denominacionPaises' | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasDesignacionesFiltroCompleto && graficasDesignacionesFiltroCompleto.graficasTab6">
                        <div class="container">
                            <div class="grafica">
                                <lib-grouped-bar-chart [horizontal]="true" [nombre]="'Kg'"
                                            [categorias]="graficasDesignacionesFiltroCompleto.graficasTab6[0].categorias" [data]="graficasDesignacionesFiltroCompleto.graficasTab6[0].designaciones"
                                            [colors]="graficasDesignacionesFiltroCompleto.graficasTab6[0].colores" [valorMaximo]="graficasDesignacionesFiltroCompleto.graficasTab6[0].valorMaximo"></lib-grouped-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.kilosDenominacion.descripcionDenominacionPaises' | translate)"><i class="fa-solid fa-info"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section">
                        <div>
                            <h3>{{'centralEstadisticas.designaciones.tabs.kilosDenominacion.denominacionKilos' | translate}}</h3>
                        </div>
                    </div>
                    <div *ngIf="graficasDesignacionesFiltroCompleto && graficasDesignacionesFiltroCompleto.graficasTab6">
                        <div class="container" *ngFor="let grafica of graficasDesignacionesFiltroCompleto.graficasTab6[1]">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="true" [nombre]="'Kg'" [title]="'(' + ('centralEstadisticas.pais' | translate) + grafica.pais + ' / ' + ('centralEstadisticas.campanya' | translate) + (grafica.anyo) + ')'"
                                            [categorias]="grafica.denominaciones" [data]="grafica.kilos" [valorMaximo]="grafica.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.kilosDenominacion.preDescripcionDenominacionKilos' | translate) + grafica.pais"><i class="fa-solid fa-info"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="estadisticas-container" *ngIf="tipoEstadisticas === 8">
            <div class="section">
                <div style="flex-direction: column;">
                    <div class= "section">
                        <div>
                            <h3>{{'centralEstadisticas.designaciones.tabs.kilosEtiquetadores.paisDenominacionCampanya' | translate}}</h3>
                        </div>
                    </div>
                    <div class="" *ngIf="graficasDesignacionesFiltroCompleto && graficasDesignacionesFiltroCompleto.graficasTab8">
                        <div class="container" *ngFor="let grafica of graficasDesignacionesFiltroCompleto.graficasTab8">
                            <div class="grafica">
                                <lib-bar-chart [horizontal]="true" [nombre]="'Kg'" [title]="'(' + ('centralEstadisticas.pais' | translate) + grafica.pais + ' / ' + ('centralEstadisticas.denominacion' | translate) + grafica.denominacion + ' / ' + ('centralEstadisticas.campanya' | translate) + (grafica.anyo) + ')'"
                                            [categorias]="grafica.etiquetadores" [data]="grafica.kilosDesignados" [valorMaximo]="grafica.valorMaximo"></lib-bar-chart>
                                <div class="buttons-section">
                                    <button [tooltip]="('centralEstadisticas.designaciones.tabs.kilosEtiquetadores.preDescripcionPaisDenominacionCampanya' | translate) + grafica.denominacion + ('centralEstadisticas.designaciones.tabs.kilosEtiquetadores.postDescripcionPaisDenominacionCampanya' | translate) + grafica.pais"><i class="fa-solid fa-info"></i></button>
                                    <!-- <button><i class="fas fa-file-pdf"></i></button>
                                    <button><i class="fas fa-file-excel"></i></button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </content>
</section>